// Terminal value 65 represents the open-ended Google Ads bucket "65+".
export const defaultAgesFromList = [18, 25, 35, 45, 55, 65];
export const defaultAgesToList = [24, 34, 44, 54, 64, 65];

export const defaultPageSize = Number(localStorage.getItem('page_size')) || 50;

export const defaultPaginationModel = {
  page: 0,
  pageSize: defaultPageSize,
  search: '',
};

export const defaultEditedUserModel = {
  id: 0,
  name: '',
  role: '',
};

export const daysOfWeekEN = [
  '',
  '',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export const daysOfWeekRU = [
  '',
  '',
  'Понедельник',
  'Вторник',
  'Среда',
  'Четверг',
  'Пятница',
  'Суббота',
  'Воскресенье',
];
